import {
  h,
} from "vue";
import DialogBody from "~/services/deleted-account-dialog/body.vue";
import DialogFooter from "~/services/deleted-account-dialog/footer.vue";
import {
  useDialogStoreV2,
} from "~/components/abstract-dialog/useDialogStoreV2";
import {
  useSessionStore,
} from "~/stores/session";

export function useDeletedAccountDialog() {
  const dialogStoreV2 = useDialogStoreV2();
  const sessionStore = useSessionStore();

  const handleLogout = () => {
    hideDialog();
    sessionStore.logout();
  };

  const {hideDialog} = dialogStoreV2.showDialog({
    titleComponent: null,
    bodyComponent: () => h(DialogBody),
    footerComponent: () =>
      h(DialogFooter, {
        onLogout: handleLogout,
      }),
    options: {
      dialogClass: "deleted-account-dialog",
      dialogWidth: "min(480px, calc(100vw - 32px))",
      dialogMinWidth: "",
      dialogMinHeight: "",
      showClose: false,
      allowCloseByEscape: false,
    },
  });
}
